module.exports = __webpack_public_path__ + "static/media/m7.45f14fd5.png";